'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper/modules';
import { useState, useRef, useEffect, useMemo } from 'react';
import { cn } from '@/shadcn/lib/utils';
import { BREAKPOINTS } from '@/shared/constants';
import { Img } from '@/shared/components/ui/Img';
import { StarFilledIcon } from '@/shared/components/icons';
import { Separator } from '@/shadcn/components/ui/separator';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { AgencyBrokerCard } from './AgencyBrokerCard';

interface Props {
    brokers: Array<any>;
    withDelay?: number;
}

export function AgencyBrokersSlider(props: Props) {
    const [sliderInit, setSliderInit] = useState(false);
    const swiperRef: any = useRef(null);
    const paginationRef = useRef<HTMLDivElement | null>(null);
    const [itemsPerSlide, setItemsPerSlide] = useState(2);

    useEffect(() => {
        const updateItemsPerSlide = () => {
            if (window.innerWidth >= BREAKPOINTS.xl) {
                setItemsPerSlide(6);
                return;
            }

            if (window.innerWidth >= BREAKPOINTS.md) {
                setItemsPerSlide(4);
                return;
            }

            setItemsPerSlide(2);
        };

        updateItemsPerSlide();

        window.addEventListener('resize', updateItemsPerSlide);

        return () => window.removeEventListener('resize', updateItemsPerSlide);
    }, []);

    useEffect(() => {
        let timer: any = 0;
        if (props.withDelay && swiperRef.current?.autoplay) {
            swiperRef.current.autoplay.stop();
            timer = setTimeout(() => {
                swiperRef.current.autoplay.start();
            }, props.withDelay);
        }

        return () => clearTimeout(timer);
    }, [props.withDelay, swiperRef.current]);

    const brokerGroups = useMemo(() => {
        const groups = [];

        for (let i = 0; i < props.brokers.length; i += itemsPerSlide) {
            groups.push(props.brokers.slice(i, i + itemsPerSlide));
        }

        return groups;
    }, [props.brokers, itemsPerSlide]);
    return (
        <div className={cn('')}>
            <div className={cn('flex justify-center items-center relative')}>
                <div className={cn('w-full')}>
                    <>
                        {brokerGroups.length > 0 && (
                            <Swiper
                                className={cn(`!pb-[80px]`, '!pt-[15px]')}
                                onSwiper={(swiper) => (swiperRef.current = swiper)}
                                modules={[Navigation, Pagination, Scrollbar, Autoplay]}
                                spaceBetween={20}
                                slidesPerView={1}
                                breakpoints={
                                    {
                                        /*[BREAKPOINTS.sm]: {
                                        slidesPerView: 2,
                                        spaceBetween: 13,
                                    },
                                    [BREAKPOINTS.md]: {
                                        slidesPerView: 2,
                                        spaceBetween: 25,
                                    },
                                    [BREAKPOINTS.lg]: {
                                        slidesPerView: 3,
                                        spaceBetween: 15,
                                    },
                                    [BREAKPOINTS.xl]: {
                                        slidesPerView: 3,
                                        spaceBetween: 30,
                                    },
                                    */
                                    }
                                }
                                loop={true}
                                autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: false,
                                }}
                                //  onBeforeInit={(swiper) => {
                                //      if (
                                //          swiper.params.pagination &&
                                //          typeof swiper.params.pagination !== 'boolean'
                                //      ) {
                                //          swiper.params.pagination.el = paginationRef.current;
                                //     }
                                // }}
                                pagination={{
                                    clickable: true,
                                }}
                                onInit={() => setSliderInit(true)}
                                // style={sliderInit ? { height: 'auto' } : { height: '0' }}
                                style={
                                    {
                                        ...(sliderInit ? { height: 'auto' } : { height: '0' }),
                                        '--swiper-pagination-color': '#000',
                                        '--swiper-pagination-bullet-inactive-color': '#ccc',
                                        '--swiper-pagination-bullet-inactive-opacity': '1',
                                    } as React.CSSProperties
                                }
                            >
                                {brokerGroups.map((group, i) => {
                                    return (
                                        <SwiperSlide
                                            key={i}
                                            style={sliderInit ? { opacity: '1' } : { opacity: '0' }}
                                        >
                                            <div className="grid grid-cols-1 gap-[15px] md:grid-cols-2 md:gap-[25px] xl:grid-cols-3 xl:gap-[30px]">
                                                {group.map((broker, brokerIndex) => {
                                                    return (
                                                        <div key={brokerIndex}>
                                                            <AgencyBrokerCard data={{}} />
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        )}
                        <div
                            ref={paginationRef}
                            className="mt-4 flex items-center justify-center gap-2"
                        />
                    </>
                </div>
            </div>
        </div>
    );
}
